const LISTE = {
  title: 'Liste des signatures électroniques',
  tab: {
    dateEnvoie: 'Date d\'envoi',
    contratEtatSignature: 'Etat de la demande',
    demandeur: 'Demandeur',
    dateSignature: 'Date de signature',
    contact: 'Contact',
    referenceCode: 'Référence code',
    tiers: 'Tiers',
    commercial: 'Commercial',
    assistant: 'Assistant',
  },
  contratEtatSignature: {
    openned: 'Envoyée',
    signed: 'Signée',
    archived: 'Signée',
    canceled: 'Annulée',
    closed: 'Close',
  },
  referenceSignature: {
    devis: 'Devis',
    commande: 'Commande',
  },
  filtre: {
    referenceCode: 'Référence code',
    commercial: 'Commercial',
    assistant: 'Assistant',
    etat: 'Etats',
  },
};

export default LISTE;
